import { SortDirection } from '../../types/DomainTypes';

export enum ViewKeys {
  SUMMARY = 'summary',
  DETIALS = 'details',
}

// export type DefaultCard = {
//   id?: string | null;
//   name?: string | null;
//   last4?: string | null;
//   expiryDate?: string | null;
//   defaultMitFlag?: boolean | null;
//   scheme?: string | null;
// };

export interface PerformanceOverTime {
  date: string;
  currentHoldings: number;
  netContributions: number;
}

export interface CurrentAllocation {
  regionName: string;
  currentAllocation: number;
  tacticalAllocation: number;
  strategicAllocation: number;
}

export interface RegionPerformance {
  regionName: string;
  currentHoldings: number;
  totalPurchasePrice: number;
  profitAndLoss: number;
  profitAndLossPct: number;
}

export interface SortByOption {
  id: string;
  value: string;
  text: string;
  content: JSX.Element;
}

export interface SortByType {
  id: string;
  text: string;
  direction: SortDirection;
}

export interface StockTotal {
  title: string;
  value: number;
  color?: string;
  text: string;
  additionalText?: string;
}

export interface ISelectedTabs {
  bidsAndOffers: { selectedId: number };
  recentTransactions: { selectedId: number };
}
